import React from 'react'
import { useTbViewStore } from '@vt/hooks'
import { Button } from '@ow/comps'
import { pick } from 'lodash-es'
import clsx from 'clsx'
import { css } from '@emotion/css'

import SharePopup from '@vt/comps/lib/share/sharePopup'
import { swapOssUrl } from '@vt/apis/lib-ex/v2/givrali'
import { getQuery } from '@vt/utils'

export const customOperateSlugs = [
  'UGMzhihuihuanweijingxihuabaogaoshengchengjieguo_1538ed2f_b82a_4f5e_9f5e_a8eee7701b45',
  '2022nianxichengqulajifenleirichangjianchaxiangmubaogaoshengchengjieguo_0a902e1a_d4d9_4b54_9da7_c0eeb9694dc6',
]
const Operate = function ({ rowData, children }) {
  const { sharedId } = getQuery()
  const { tbSlug } = useTbViewStore((state) =>
    pick(state, ['tbSlug', 'destroyTbData', 'updateTbData'])
  )

  if (customOperateSlugs.indexOf(tbSlug) !== -1) {
    return (
      <div>
        <Button
          type="primary"
          style={{
            fontSize: '14px',
            margin: '0 -7px',
          }}
          onClick={() => {
            console.log('rowdata', rowData)
            const arr = rowData.reportOss.split('?')
            const filename = arr[0] && arr[0].split('.com/')[1]
            if (filename) {
              swapOssUrl([filename]).then((res) => {
                // eslint-disable-next-line prefer-destructuring
                window.location.href = res.data[0]
              })
            }
          }}
        >
          下载报告
        </Button>
      </div>
    )
  }

  if (
    tbSlug === 'shujuliebiao_71165c22_acc7_4298_bf42_3970af125b81' &&
    !sharedId
  ) {
    return (
      <div
        className={clsx(
          'w-full flex items-center',
          css`
            .row-operate {
              visibility: visible !important;
              background: transparent !important;
            }
          `
        )}
      >
        <div style={{ transform: 'translateX(-38px)', visibility: 'visible' }}>
          <SharePopup objectId={rowData?.objectId}>
            <Button
              type="primary"
              opacityType="transparent"
              style={{
                fontSize: '13px',
              }}
            >
              分享
            </Button>
          </SharePopup>
        </div>
        {children}
      </div>
    )
  }
  return children
}

export default Operate
